<app-trial-ended-cta
  [upgradeUrl]="upgradeUrl"
  (downgradeClick)="onDowngrade()"
></app-trial-ended-cta>
